import "./styles/message-banner.sass"
export function MessageBanner({ message = "" }: { message?: string }) {
    return (<div id="message-banner">{message}</div>)

}
